// extracted by mini-css-extract-plugin
export default {"cls1":"_yR49l4yJ72zy1or5qX3","cls2":"BFExF5KNk18WeMYJ7JzE _yR49l4yJ72zy1or5qX3","isDesktopUp":"I27ZB7iSqYPcRngWbUgT"};